export default __webpack_public_path__ + "static/media/MP_1.ad4d7454.png";